<template>
  <button
    :name="name"
    :style="btnIconStyle"
    :disabled="disable || loading"
    @click="$emit('btn-click')"
  >
    <soha-circular-loading
      v-if="loading"
      :variant="iconColor"
      :size="loadingSize"
      style="margin-top: 0.615rem"
    />
    <span
      v-else
      :class="`svg-icon svg-icon-${iconSize} svg-icon-${iconColor} d-flex align-items-center justify-content-center`"
    >
      <inline-svg
        :src="`/media/svg/soha/icons/${icon}.svg`"
        :style="xSmall && 'width: 10px!important'"
      />
    </span>
  </button>
</template>

<script>
import "@/assets/css/components/base/circular-loading.css";

export default {
  name: "ButtonIcon",

  props: {
    iconColor: {
      default: "primary",
      type: String,
    },
    iconSize: {
      default: "md",
      type: String,
    },
    backgroundColor: {
      default: "white",
      type: String,
    },
    borderRadius: {
      default: "5",
      type: String,
    },
    borderSize: {
      default: "1",
      type: String,
    },
    borderColor: {
      default: null,
      type: String,
    },
    icon: {
      default: null,
      type: String,
    },
    small: {
      default: false,
      type: Boolean,
    },
    xSmall: {
      default: false,
      type: Boolean,
    },
    name: {
      type: String,
      require: true,
      default: null,
    },
    disable: {
      type: Boolean,
      require: false,
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },

  emits: ['btn-click'],

  computed: {
    btnIconStyle() {
      return {
        padding: "0!important",
        "background-color": `var(--${this.backgroundColor}-color)`,
        "border-radius": `${this.borderRadius}px`,
        border: `${this.borderSize}px solid var(--${this.borderColor}-color)`,
        height: `${this.xSmall ? "24px" : this.small ? "32px" : "50px"}`,
        width: `${this.xSmall ? "24px" : this.small ? "32px" : "50px"}`,
        cursor: this.disable ? "not-allowed" : "pointer",
      };
    },

    loadingSize() {
      return this.xSmall ? "12" : this.small ? "16" : "25";
    },
  },
};
</script>
